<template>
    <div class="empty" :class="type">
        <div class="empty-icon" :class="type"></div>
        <div class="empty-text">{{text}}</div>
    </div>
</template>
<script>
    export default {
        props: {
            text: {
                type: String,
                default: "没有数据"
            },
            type: {
                type: String,
                default: "default"
            }
        }
    };

</script>
<style scoped>
    .empty {
        text-align: center;
    }

    .empty.cart {
        text-align: center;
        position: absolute;
        margin-left: 50%;
        left: -86px;
        top: 50%;
        margin-top: -100px;
    }

    .empty-icon {
        width: 399px;
        height: 290px;
        margin: 24px auto;
        text-align: center;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
    }

    .empty-icon.default {
        background-image: url("https://static.711.cn/assets/image/ph/empty_data_3.png");
    }

    .empty-icon.cart {
        background-image: url("https://static.711.cn/assets/image/ph/empty_cart.png");
        width: 171px;
        height: 136px;
    }

    .empty-text {
        font-size: 12px;
        color: #666;
    }

</style>



// WEBPACK FOOTER //
// src/components/_widget/Empty.vue